// @flow

import React from 'react';
import {SortableElement, SortableHandle} from 'react-sortable-hoc';
import styled from 'styled-components';
import { isThemeiOS } from '../../themes';
import Item from './item';
import ReorderBar from '../../icons/android-reorder.svg';

const BarsBase = styled.div`
  user-select: initial;
`;

export const AndroidBars = styled(BarsBase).attrs({
  dangerouslySetInnerHTML: {
    __html: ReorderBar
  }
})`
  &, > svg {
    width: 18px;
    height: 16px;
  }
`;

export const IOSBars = styled(BarsBase)`
  width: 22px;
  height: 9px;
  border-top: 1px solid #D6D6D6;
  position: relative;

  &:before, &:after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 3px;
    left: 0;
    width: 100%;
    height: 1px;
    border-top: 1px solid #D6D6D6;
  }

  &:after {
    top: 6px;
  }
`;

const DragHandle = SortableHandle(() =>
  isThemeiOS() ? <IOSBars /> : <AndroidBars />
);

export default SortableElement(({ ...props }) =>
  <Item {...props} DragHandle={DragHandle} />
);



// WEBPACK FOOTER //
// ./src/components/Item/sortable-item.js